'use-strict';

/* @ngInject */
export default function routing($routeProvider) {
  const LoginTemplate = require('./login-screen/login-screen.template.html');

  $routeProvider
    .when('/login', {
      templateUrl: LoginTemplate,
      title: 'Login',
    })
    .when('/super-admin-login', {
      templateUrl: LoginTemplate,
      title: 'Super Admin Login',
    });
}
